export default "__VITE_ASSET__BcahsDUl__"